import Vue from "vue";
import Vuex from "vuex";
import exportConfig from "./export";
import authentication from "./authentication";
import mailSubscribe from "./mailSubscribe";
import games from "./games";
import kioskGlobal from "./kioskGlobal";
import kioskGlobalUpdated from "./kioskGlobalUpdated";
import staff from "./staff";
import maintenance from "./maintenance";
import operations from "./operations";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    exportConfig,
    authentication,
    mailSubscribe,
    games,
    kioskGlobal,
    kioskGlobalUpdated,
    staff,
    maintenance,
    operations
  },
});
